<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<BackButton
				@back-click="handleBackButton"
				class="arrow-btn arrow-btn-back--grey top"
			/>
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form
			class="w-100"
			@submit.prevent
		>
			<div class="rounded-container">
				<div class="row">
					<div class="col">
						<h2 class="h4 mb-4 mt-custom-1">{{ microcopy?.mortgageDealEndingLabel }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col d-flex flex-column flex-md-row rounded-container__btn-col rounded-container__btn-col-x2--small">
						<fieldset>
							<legend class="visually-hidden"><span>Please select an option</span></legend>
							<RadioInputComponent
								v-for="option in options"
								:key="option"
								:options="option"
								:selected-option="selected"
								@selected="(payload) => {
									selected = payload;
									postMortgageDealEnding(payload);
									if (payload.selected) {
										scrollToNextQuestion('current-mortgage-provider-label');
									}
								}"
							/>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<h2 class="h4 mb-4 mt-custom-1" id="current-mortgage-provider-label">{{ microcopy?.currentMortgageProviderDropdownLabel }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-6 d-flex flex-column flex-md-row">
						<DropdownField
							
							:options="mappedMortgageProviders"
							:error-text="microcopy?.currentMortgageProviderDropdownError"
							@selected="(payload) => {
								previousMortgageProvider = payload;
								postMortgageProvider(payload);
								scrollToNextQuestion('continue-button');
							}"
							class="w-100"
						/>
					</div>
				</div>
				<div class="row btm-btn-group__contained">
					<div class="col d-flex flex-column align-items-start">
						<GenericButton
							id="continue-button"
							:label-text="progressionText"
							:button-disabled="buttonDisabled"
							@button-click="handleClick"
						/>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import BackButton from '@/shared/components/BackButton.vue';
import DropdownField from '@/shared/components/DropdownField.vue';

import router from '../router/index.js';

import { mapStores, mapActions, mapState } from 'pinia';
import { useMortgageStore } from '../stores/mortgageStore.js';

export default {
	components: {
		RadioInputComponent,
		GenericButton,
		BackButton,
		DropdownField,
	},
	data() {
		return {
			microcopy: '',
			mappedMortgageProviders: [],
			options: {
				alreadyEnded: {
					text: 'It\'s already ended',
				},
				withinAMonth: {
					text: 'Within the next month',
				},
				withinSixMonths: {
					text: 'Within the next six months',
				},
				inMoreThanSixMonths: {
					text: 'In more than six months',
				},
			},
			selected: {},
			progressionText: 'Continue',
			mortgageProviders: ['Halifax', 'Barclays', 'HSBC', 'Lloyds', 'Nationwide', 'NatWest', 'Santander', 'TSB', 'VirginMoney', 'Other'],
			previousMortgageProvider: '',
		};
	},
	computed: {
		...mapStores(useMortgageStore),
		...mapState(useMortgageStore, ['mortgageDealEnding', 'mortgageProvider']),
		nextPage() {
			return 'remortgaging-needs';
		},
		buttonDisabled() {
			return !this.selected.selected || this.previousMortgageProvider === '';
		},
	},
	methods: {
		...mapActions(useMortgageStore, ['postMortgageDealEnding', 'postMortgageProvider']),
		handleClick() {
			scrollTo({ top: 0, behavior: 'smooth' });
			router.push(this.nextPage);
		},
		handleBackButton() {
			router.back();
		},
		scrollToNextQuestion(nextQuestionID) {
			this.$nextTick(() => {
				let nextQuestion = document.getElementById(nextQuestionID);
				if (!nextQuestion && nextQuestionID !== 'continue-button') {
					nextQuestion = document.getElementById('continue-button'); 
				}
				if (!nextQuestion) {
					return;
				}
				nextQuestion.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			});
		},
	},
	mounted() {
		if (this.mortgageDealEnding) {
			this.selected = this.mortgageDealEnding;
		}
		this.microcopy = window.mortgageRequestMicrocopy.currentMortgage;
		document.title = this.microcopy?.metaTitle
		this.mappedMortgageProviders = this.microcopy?.currentMortgageProviderDropdownOptions.map(element => element['text']);
	},
};
</script>
